// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { get, map, values } from 'lodash/fp';
import { compose, withProps } from 'recompose';
import * as sportCategoriesActions from '../../actions/sportCategoriesActions';
import Loader from '../../components/commons/Loader';
import withAPICollection from '../../hoc/withAPICollection';
import { getSlates } from '../../api/h2h';
import CreateChallenge from './CreateChallenge';

type Props = {
  adminRakePercentage?: number,
  allowedEntryCosts?: Array<number>,
  getSportCategories: () => void,
  loading: boolean,
  h2h?: Object,
  multiPlayers?: Object,
  onFetch: () => void,
  slates?: Array<Object>,
  sportsList?: Array<Object>,
  userRakePercentage?: number
};

const defaultProps = {
  slates: undefined,
  sportsList: undefined,
  adminRakePercentage: undefined,
  allowedEntryCosts: undefined,
  userRakePercentage: undefined,
  h2h: undefined,
  multiPlayers: undefined
};

const LoadCreateChallenge: React.FC<Props> = ({
  adminRakePercentage,
  allowedEntryCosts,
  loading,
  getSportCategories,
  h2h,
  multiPlayers,
  onFetch,
  slates,
  sportsList,
  userRakePercentage
}: Props) => {
  const fetchCategories = () => {
    if (sportsList.length === 0) {
      getSportCategories();
    }
  };

  React.useEffect(onFetch, []);
  React.useEffect(fetchCategories, []);

  if (sportsList.length === 0 || loading || allowedEntryCosts === undefined) {
    return <Loader />;
  }
  return (
    <CreateChallenge
      adminRakePercentage={adminRakePercentage}
      allowedEntryCosts={allowedEntryCosts}
      h2h={h2h}
      multiPlayers={multiPlayers}
      slates={slates}
      sportsList={sportsList}
      userRakePercentage={userRakePercentage}
    />
  );
};

LoadCreateChallenge.defaultProps = defaultProps;

const mapStateToProps = state => ({
  sportsList: values(state.sportCategories.items)
});

const actions = {
  getSportCategories: sportCategoriesActions.getSportCategories
};

const connector = connect(mapStateToProps, actions);

export const decodeSlate = data => ({
  id: data.id,
  name: data.name,
  sportId: data.sport_id,
  competitionId: get('competition_type.id', data),
  startTime: data.start_time,
  competitionType: {
    id: get('competition_type.id', data),
    name: get('competition_type.short_name', data),
    sportIcon: get('competition_type.sport.icon', data)
  },
  challengeRuleType: get('challenge_rule.type', data)
});

const apiWrapper = compose(
  withAPICollection({
    fetcher: getSlates,
    normalizeData: map(decodeSlate)
  }),
  withProps(props => ({
    slates: props.items,
    adminRakePercentage: get('meta.custom_challenge.admin_rake_percentage', props),
    allowedEntryCosts: get('meta.custom_challenge.allowed_entry_cost', props),
    h2h: {
      qty: {
        max: get('meta.custom_challenge.h2h.maximum_quantity_per_entry_cost', props),
        min: 1
      },
      qtyFree: {
        max: get('meta.custom_challenge.h2h.maximum_quantity_per_free', props),
        min: 1
      }
    },
    multiPlayers: {
      qtyPerUser: get('meta.custom_challenge.multi_players.maximum_entries_per_user', props),
      prizeStructure: get('meta.custom_challenge.multi_players.pay_structure', props)
    }
  }))
);

export default compose(apiWrapper, connector)(LoadCreateChallenge);
